module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rolesList"
  }, [_c('br'), _c('br'), _vm._v(" "), (_vm.loaded == false) ? _c('center', [_c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../shared/assets/images/3dloader.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.loaded == true) ? _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.userRoles,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          staticClass: "px-1",
          attrs: {
            "width": "5%"
          }
        }, [_c('v-btn', {
          staticClass: "sortHandle",
          staticStyle: {
            "cursor": "move"
          },
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("drag_handle")])], 1)], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('RFC_REPORT') !== -1) ? _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(props.item.name) + " "), _c('small', [_vm._v("( Level " + _vm._s(props.item.level) + " )")])]) : _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.name) + " "), _c('small', [_vm._v("( Level " + _vm._s(props.item.level) + " )")])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "35%"
          }
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(_vm.userTypes[props.item.user_type]))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(props.item.active))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('EDIT_ROLE_PRICELISTS') !== -1) ? _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRolePlists(props.item.id, props.item.name)
            }
          }
        }, [_vm._v("Pricelists")])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('RFC_REPORT') !== -1) ? _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRoleStatus(props.item.id, props.item.name)
            }
          }
        }, [_vm._v("RFC Status")])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('EDIT_ROLE_PRIVS') !== -1) ? _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncGetRolePrivs(props.item.id, props.item.name)
            }
          }
        }, [_vm._v("Privileges")])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1) ? _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncShowEdit(props.item.id, props.item.name)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1) ? _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRoleDelete(props.item.id, props.item.linked_users, props.item.name)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])]) : _vm._e()])]
      }
    }], null, false, 3321828891)
  }) : _vm._e()], 1)
},staticRenderFns: []}